<template>
<div>
<querytitle>
  <template slot="queryleft">
    <div>模糊查找：</div>
    <div><el-input v-model="querykey" size="mini"></el-input></div>
    <div><el-button type="primary" size="mini" @click="getlist()">查找</el-button></div>
  </template>
  <template slot="queryright">
    <el-button type="primary" size="mini" @click="add()">新增</el-button>
    <fileimportbutton :par="pars" :classname="'sys_org'" :okupload="uploaded"></fileimportbutton>
  </template>
</querytitle>
<el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
  <el-table-column prop="orgname" label="机构名称" width="200"></el-table-column>
  <el-table-column prop="orgtel" label="机构电话" width="100"></el-table-column>
  <el-table-column prop="orgaddress" label="机构地址" width="100"></el-table-column>
  <el-table-column prop="orggps" label="机构定位" width="100"></el-table-column>
  <el-table-column prop="orgtype" label="机构类型" width="100"></el-table-column>
  <el-table-column prop="areaname" label="所属区域" width="100"></el-table-column>
  <el-table-column prop="arealevel" label="区域级别" width="100"></el-table-column>
  <el-table-column prop="orgother" label="备注"></el-table-column>
  <el-table-column prop="orgpic" label="组织机构代码证" width="150"></el-table-column>
  <el-table-column prop="LOGO" label="图标" width="100"></el-table-column>
  <el-table-column fixed="right" label="操作" width="150">
    <template slot-scope="scope">
     <el-button @click="edit(scope)" type="primary" size="mini">编辑</el-button>
      <el-button type="danger" size="mini" @click="del(scope)">删除</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="rt">
</el-pagination>
<el-dialog title="组织机构信息" :visible="dialogFormVisible" :show-close="false" width="80%">
<el-form label-width="100px">
  <el-row>
    <el-col :span="18">
      <el-row>
        <el-col :span="8">
          <el-form-item label="机构代码">
            <el-input v-model="itemedit.orgid" :disabled="!addflag" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="机构名称">
            <el-input v-model="itemedit.orgname" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="机构电话">
            <el-input v-model="itemedit.orgtel" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="机构定位">
            <el-input v-model="itemedit.orggps" @input="inputmethod()" placeholder="请输入经度,纬度"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" style="line-height:40px;">
          <el-link href='https://lbs.amap.com/tools/picker' target="_blank" type="primary">拾取</el-link>
        </el-col>
        <el-col :span="8">
          <el-form-item label="机构类型">
            <el-select v-model="itemedit.orgtype" placeholder="请选择">
              <el-option v-for="item in types" :key="item.FID" :label="item.FVALUE" :value="item.FID"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="机构地址">
            <el-input v-model="itemedit.orgaddress" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        
        
        <el-col :span="8">
          <el-form-item label="所属区域">
            <el-cascader v-model="itemedit.areaid"
            :options="areas"
            :props="{ value:'value',label:'text',checkStrictly: true }"
            @change="areaChange"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开户银行">
            <el-input v-model="itemedit.bank" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行账户">
            <el-input v-model="itemedit.bankid" @input="inputmethod()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="itemedit.orgother" @input="inputmethod()" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="6">
      <el-row>
        <el-col :span="24">
          <el-form-item label="机构LOGO">
            <el-upload
              class="avatar-uploader"
              action="api/SYS/uploadBigFile"
              :headers="{Authorization:'Bearer ' + CU.token}"
              :data="{amid:'',sqladd:false}"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="itemedit.LOGO" :src="itemedit.LOGO" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="社会信用代码" label-position="top">
            <el-upload
              class="avatar-uploader"
              action="api/SYS/uploadBigFile"
              :headers="{Authorization:'Bearer ' + CU.token}"
              :data="{amid:'',sqladd:false}"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload">
              <img v-if="itemedit.pospic" :src="itemedit.pospic" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  

  
</el-form>
<div slot="footer" class="dialog-footer">
 <el-button @click="dialogFormVisible=false">取 消</el-button>
 <el-button type="primary" @click="postdata()">确 定</el-button>
</div>

</el-dialog>
</div>
</template>
<script>
import querytitle from '@/components/querytitle'
import fileimportbutton from '@/components/fileimportbutton'
export default {
components: {
  querytitle,fileimportbutton
},
data() {
  return {
    hh: 500,
    areas:[],
    loading:false,
    addflag: false,
    itemlist: [],
    itemindex: 0,
    itemedit: {},
    dialogFormVisible: false,
    rt: 0,
    currentPage: 1,
    pagesize: 10,
    pars:{objname:'sys_org'},
    querykey:"",
    types:[]
  };
},
created() {
  let that = this
  this.hh = document.documentElement.clientHeight - 220;
  this.getlist();
  that.GETENUM('sys_org','orgtype',false,function(res){
    that.types = res
  })
  that.GetData('SYS/GetCurrentAreas',{flag:'yes'},function(res){
    that.areas = res.data.areas
  },function(err){})
},
methods: {
  areaChange(value){
    let that = this
    that.itemedit.areaname =''
    for(var item of value){
      var xx =that.getnode(null,that.areas,'value',item)
      that.itemedit.areaid = xx.node.value;
      if(that.itemedit.areaname)
        that.itemedit.areaname += "/" + xx.node.text
      else
        that.itemedit.areaname = xx.node.text
    }
  },
  add() {
    this.itemedit = {};
    this.addflag = true;
    this.itemedit.orgid = "";
    this.dialogFormVisible = true;
  },
  edit(par) {
    this.addflag = false;
    this.itemindex = par.$index;
    this.itemedit = Object.assign({}, par.row);
    this.dialogFormVisible = true;
  },
  del: function (par) {
    let that = this;
    that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        var pars = {objname: "sys_org",model: par.row};
        that.PostData("Common/DEL",pars,function (res) {
            if (res.data.error_code != 0) {
             that.$alert(res.data.message, {title: "错误"});
             return;
             }
             that.itemlist.splice(par.$index, 1);
          },function (err) {
            that.$alert(err, {title: "错误",type: 'error'});
          }
        );
      })
      .catch(() => {});
    },
    postdata() {
      let that = this;
      if (!that.itemedit.orgid) {
        that.$alert("代码不能为空", {title: "提示"});return;
      }
      let pars = {objname: "sys_org",model: Object.assign({}, that.itemedit)};
      if (that.addflag) {
          that.PostData("Common/ADD",pars,function (res) {
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {title: "错误"});return;
            }
            that.itemlist.push(pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      } else {
        that.PostData("Common/EDIT",pars,function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, {title: "错误"});return;
          }
            that.$set(that.itemlist, that.itemindex, pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      }
    },
    getlist() {
        let that = this
        let wherestring = []
        if(this.querykey){
          wherestring = [{field: 'orgid',sym: 'like',val: this.querykey,oper: 'or'},]
        }
        let pars = {objname: "sys_org",wheres: wherestring,PageSize: that.pagesize,CurrentPage: that.currentPage}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.itemlist = res.data.data;
          that.rt = res.data.rowTotal
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
    uploaded(){
      this.getlist()
    },
    beforeAvatarUpload(file){
      console.log(file)
    },
    handleAvatarSuccess(res, file, fileList){
      this.itemedit.LOGO = res.obj.apurl
    },
    handleAvatarSuccess1(res, file, fileList){
      this.itemedit.orgpic = res.obj.apurl
    },
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>